export const defaultThemeProps = {
  svgProps: {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%',
  },
  facing: 'back'
}
